module.exports = __webpack_public_path__ + "8222e2a930ffe19923450affdf3e45b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/trump-header/imgs/header2.jpg
// module id = 99
// module chunks = 0